import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  cancelButton: {
    marginRight: 16,
  },
  submitButton: {
    flex: 1,
    padding: '9px 6px',
  },
}))
